import { render, staticRenderFns } from "./ProductItem5.vue?vue&type=template&id=3a189a40&"
import script from "./ProductItem5.vue?vue&type=script&lang=js&"
export * from "./ProductItem5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports